import { render, staticRenderFns } from "./IPlus.vue?vue&type=template&id=1c23b682&"
import script from "./IPlus.vue?vue&type=script&lang=ts&"
export * from "./IPlus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports